import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getMAWBInfoOtherChargeList(params) {
  return request({
    url: URL.partner.mawbInfoOtherCharge,
    method: 'get',
    params
  })
}

export function saveMAWBInfoOtherCharge(data) {
  return request({
    url: URL.partner.mawbInfoOtherCharge,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delMAWBInfoOtherCharge(uuid) {
  return request({
    url: URL.partner.mawbInfoOtherCharge + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
